module.exports = __webpack_public_path__ + "static/photo-19a228ff3a23a696e67e09a24bc3d7ab.jpg";